var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap wrap-summary"},[_c('div',{staticClass:"banner"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/img/jianjie.png"),"alt":"擎科生物"}}),_vm._v(" "),_c('qk-top-menu',{attrs:{"menuLists":_vm.menuLists}})],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c8e94bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/summary/index.vue
// module id = null
// module chunks = 